import React, { useState, Context, ReactElement, Component } from "react";

export interface pods_type {
  kind: string;
  items: pods_type_item[];
}

export interface pods_type_item {
  kind: string;
  metadata: {
    name: string;
  };
  uid: string;
  status: string;
  name: string;
  creationTimestamp: string;
  node: string;
  containers: {
      name: string;
      image: string;
      resources: {
          limits: object;
          requests: object;
      };
      restart: string;
  }
}

const PodsContext: Context<[pods_type_item[] | undefined, React.Dispatch<React.SetStateAction<pods_type_item[] | undefined>>]> = React.createContext<[pods_type_item[] | undefined, React.Dispatch<React.SetStateAction<pods_type_item[] | undefined>>]>([[] as unknown as pods_type_item[] | undefined, (_value: any) => { }]);

const PodsProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [pods, set_pods]: [pods_type_item[] | undefined, React.Dispatch<React.SetStateAction<pods_type_item[] | undefined>>] = useState([] as unknown as pods_type_item[] | undefined);
  return (
    <PodsContext.Provider value={[pods, set_pods]}>
      {props.children}
    </PodsContext.Provider>
  )
}

export { PodsContext, PodsProvider };
